import { useEffect, useState } from "react";

// Debounced duplicate/uniqueness checker. `fetcher` returns the check result.
export function useDuplicateCheck(fetcher, deps, enabled = true) {
  const [result, setResult] = useState(null);
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setResult(null);
      return undefined;
    }
    let active = true;
    setChecking(true);
    const timer = setTimeout(async () => {
      try {
        const r = await fetcher();
        if (active) setResult(r);
      } catch {
        if (active) setResult(null);
      } finally {
        if (active) setChecking(false);
      }
    }, 400);
    return () => {
      active = false;
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { result, checking };
}
